// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-ip[data-v-22d6663b] {\n  background: #FEFCD8;\n}\n.not-recommended[data-v-22d6663b] {\n  color: #eb5757;\n}", ""]);
// Exports
module.exports = exports;
